import type { ReactNode } from "react";

export interface ModalSectionProps {
  id: string;
  title: string;
  children: ReactNode;
}

export function ModalSection(props: ModalSectionProps) {
  const { id, title, children } = props;

  return (
    <div className="w-full grid grid-cols-8 sm:grid-cols-12 gap-y-8 gap-x-6 lg:gap-x-8 items-start lg:items-center">
      <div className="col-span-8 sm:col-span-12">
        <section aria-labelledby={`content-${id}`}>
          <h3 id={`content-${id}`} className="sr-only">
            {title}
          </h3>
          {children}
        </section>
      </div>
    </div>
  );
}
